import React, { useState, useEffect, useRef } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import { Logo } from '../../components';
import './navbar.css';
// talvez adicionar um novo item aqui além de ajustes no estilo
const Menu = ({ isPastSobreSection }) => (
  <>
    <p><a href="#home" className={`navbar-link ${isPastSobreSection ? 'past-sobre' : ''}`}>Início</a></p>
    <p><a href="#sobre" className={`navbar-link ${isPastSobreSection ? 'past-sobre' : ''}`}>Sobre Mim</a></p>
    <p><a href="#especialidade" className={`navbar-link ${isPastSobreSection ? 'past-sobre' : ''}`}>Especialidades</a></p>
    <p><a href="#infos" className={`navbar-link ${isPastSobreSection ? 'past-sobre' : ''}`}>Como Funciona?</a></p>
    <p><a href="#contato" className={`navbar-link ${isPastSobreSection ? 'past-sobre' : ''}`}>Contato</a></p>
  </>
);

const NavBar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [closingMenu, setClosingMenu] = useState(false);
  const [isPastSobreSection, setIsPastSobreSection] = useState(false);
  const [applyBlur, setApplyBlur] = useState(false);
  const [removeBlur, setRemoveBlur] = useState(false);
  const menuRef = useRef(null);

  const [applyShadow, setApplyShadow] = useState(false);
  const [removeShadow, setRemoveShadow] = useState(false);

  useEffect(() => {
    const handleScrollBlur = () => {
      const scrollPosition = window.scrollY;
      const headerHeight = 0;

      if (scrollPosition > headerHeight && !applyShadow) {
        setApplyShadow(true);
        setRemoveShadow(false);
      } else if (scrollPosition <= headerHeight && applyShadow) {
        setApplyShadow(false);
        setRemoveShadow(true);
      }
    };

    window.addEventListener('scroll', handleScrollBlur);
    return () => {
      window.removeEventListener('scroll', handleScrollBlur);
    };
  }, [applyShadow, removeShadow]);


  // useEffect(() => {
  //   const handleScroll = () => {
  //     const sobreSection = document.getElementById('sobre');

  //     if (sobreSection) {
  //       const sobreSectionTop = sobreSection.offsetTop;

  //       setIsPastSobreSection(window.scrollY >= sobreSectionTop);
  //     };
  //   };

  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  useEffect(() => {
    const handleScrollBlur = () => {
      const scrollPosition = window.scrollY;
      const headerHeight = 75;

      if (scrollPosition > headerHeight && !applyBlur) {
        setApplyBlur(true);
        setRemoveBlur(false);
      } else if (scrollPosition <= headerHeight && applyBlur) {
        setApplyBlur(false);
        setRemoveBlur(true);
      }
    };

    window.addEventListener('scroll', handleScrollBlur);
    return () => {
      window.removeEventListener('scroll', handleScrollBlur);
    };
  }, [applyBlur, removeBlur]);

  const handleMenuClose = () => {
    setClosingMenu(true);
    setTimeout(() => {
      setToggleMenu(false);
      setClosingMenu(false);
    }, 300);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleMenuClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`psico__navbar ${isPastSobreSection ? 'past-sobre' : ''}`} id="navbar">
      <div className={`navbar__fixed ${applyShadow ? 'navbar-shadow' : ''} ${removeShadow ? 'navbar-no-shadow' : ''}`}>
      <div className="psico__navbar-links">
        <div className="psico__navbar-links_logo">
          <a href="#home">
            <Logo isPastSobreSection={isPastSobreSection} />
          </a>
        </div>
        <div className="psico__navbar-links_container">
          <Menu isPastSobreSection={isPastSobreSection} />
        </div>
      </div>

      <div className="psico__navbar-menu" ref={menuRef}>
        {toggleMenu
          ? <RiCloseLine color={isPastSobreSection ? 'var(--color-2)' : 'FFF'} size={27} onClick={handleMenuClose} />
          : <RiMenu3Line color={isPastSobreSection ? 'var(--color-2)' : 'FFF'} size={27} onClick={() => setToggleMenu(true)} />
        }
        {
          toggleMenu && (
            <div
              className={`psico__navbar-menu_container ${closingMenu ? 'scale-out-tr' : 'scale-up-tr'
                }`}
            >
              <div className="psico__navbar-menu_container-links">
                <Menu isPastSobreSection={isPastSobreSection} />
              </div>
            </div>
          )
        }
      </div>
      </div>
    </div>
  );
};

export default NavBar;
